import { Button, Grid } from '@material-ui/core';
import { getInviteExternal, getJobs, consumeInviteExternal } from '@webapps/business';
import { FormikAutocompletePx, useAuth, useQuery, useMutation, useToast } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';

import Modal from 'components/Modal';
import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const ExternalInvite = ({invite, removeInvite}) => {
  const { classes, css, theme: { fontSizes, spacing } } = useStyles(styles);

  const { idUser, profile } = useAuth();
  const [modalInvite, setModalInvite] = useState(false);
  const [keywordRequest, setKeywordRequest] = useState('');
  const { addToast } = useToast();

  const { data: { content: jobs = [] } = {} } = useQuery(getJobs, {
    key: ['jobs', keywordRequest],
    variables: { keyword: keywordRequest || '' },
  });

  const {
    data: inviteExternal = {},
    isSuccess,
    mutateAsync: mutateGetInviteExternal,
  } = useMutation(getInviteExternal);

  const {
    isSuccess: isSuccessConsume,
    isError: isErrorConsume,
    mutateAsync: mutateConsumeInviteExternal,
  } = useMutation(consumeInviteExternal);

  const validationSchema = Yup.object({
    job: Yup.object()
      .shape({
        ogr: Yup.string().required('Requis'),
      })
      .required('Requis'),
  });
  

  const formik = useFormik({
    initialValues: {
      job: {
        ogr: '',
      },
    },
    validationSchema,
    onSubmit: async (values) => {
      await mutateConsumeInviteExternal({ id: invite.id, job: values.job.ogr, action: 'accept'});
    },
  });

  useEffect(() => {
    if (invite?.id) {
      switch (invite.type) {
        case 'BUSINESS-CONTRACT':
          mutateGetInviteExternal({ id: invite.id, from: 'invite' });
          break;
        default:
          break;
      }
    }
  }, [invite]);

  useEffect(() => {
    if (isSuccess && inviteExternal?.id) {
      setModalInvite(true);
    }
    if(isSuccessConsume) {
      setModalInvite(false);
      removeInvite();
      addToast({
        status: 'success',
        message: 'L\'étudiant a bien été ajouté à votre entreprise',
      });
      window.location.reload();
    }
    if(isErrorConsume) {
      addToast({
        status: 'error',
        message: 'Une erreur est survenue',
      });
    }
  }, [isSuccess, isSuccessConsume, isErrorConsume]);

  return (
    <div className={classes.container}>
      <Modal
      open={modalInvite}
      title="Un étudiant souhaite rejoindre votre entreprise"
      onCancel={() => {setModalInvite(false); removeInvite()}}
      >
        <div>
          <p>L'étudiant {inviteExternal?.student?.firstname} {inviteExternal?.student?.lastname} souhaite rejoindre votre entreprise dans le cadre d'un contrat</p>
          <p>Pour ce faire, vous devez choisir l'intitulé du poste dans lequel l'étudiant travaillera</p>
        </div>
        <Grid item xs={12}>
          <FormikAutocompletePx
            defaultValue=""
            formik={formik}
            fullWidth
            getOptionLabel={(option) => option.label || ''}
            getOptionSelected={(option, value) => value.ogr === option.ogr}
            label="Indiquer un intitulé de poste"
            name="job.ogr"
            onInputChange={(event, value) => {
              setKeywordRequest(value);
            }}
            options={jobs}
            pathValue="ogr"
            value={
              jobs.find(({ ogr }) => ogr === formik.values.job.ogr) || null
            }
          />
        </Grid>
        <Button
          color="primary"
          onClick={formik.handleSubmit}
          variant="contained"
        >
          Accepter
        </Button>
        <Button
          color="secondary"
          onClick={() => mutateConsumeInviteExternal({ id: invite.id, job: formik.values.job.ogr, action: 'reject'})}
          variant="contained"
        >
          Rejeter
        </Button>
      </Modal>
    </div>  
  );
};

const styles = ({ fontSizes, spacing }) => ({
  container: {
    // height: '100%',
    padding: spacing(5),
    // minHeight: '100vh',
    fontSize: fontSizes(16),
    fontWeight: 400,
    color: '#959DB1',
    lineHeight: '100%',
    '@media only screen and (max-width:768px)': {
      padding: spacing(3, 2, 2, 2),
    },
    '@media (max-width:1380px)': { fontSize: fontSizes(15) },
    '@media (max-width:1278px)': { fontSize: fontSizes(14), },
    '@media (max-width:1227px)': { fontSize: fontSizes(13), },
    '@media (max-width:1020px)': { fontSize: fontSizes(16), },
  },
});

export default ExternalInvite;